"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickChatBox = QuickChatBox;
const React = __importStar(require("react"));
const react_jss_1 = require("react-jss");
const react_redux_1 = require("react-redux");
const quickChat_1 = require("~/store/game/quickChat");
const useStyles = (0, react_jss_1.createUseStyles)({
    box: {
        textAlign: "center",
        fontWeight: 700,
    },
});
/** Renders the emote a given player most recently sent. */
function QuickChatBox({ playerId }) {
    const styles = useStyles();
    const currentChat = (0, react_redux_1.useSelector)((0, quickChat_1.selectPlayerQuickChat)(playerId !== null && playerId !== void 0 ? playerId : ""));
    if (!playerId || !currentChat) {
        return null;
    }
    return React.createElement("div", { className: styles.box }, currentChat.value);
}
